import { render, staticRenderFns } from "./FullScreenModal.vue?vue&type=template&id=c0c7b08a&scoped=true"
import script from "./FullScreenModal.vue?vue&type=script&lang=js"
export * from "./FullScreenModal.vue?vue&type=script&lang=js"
import style0 from "./FullScreenModal.vue?vue&type=style&index=0&id=c0c7b08a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0c7b08a",
  null
  
)

export default component.exports